import React, { useState, useEffect,useMemo, createElement } from "react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import Srcset from "./Srcset";
import styles from "../QuickBuyComp/QuickBuyComp.module.scss";
import PopUp from "./ReactPortal/PortalPopUp.js";
import commonStyle from "./common.module.scss";
import SizeGuidePopUp from "./SizeGuidePopUp";
import { getShopifyTagData, getSizeGuideType } from "@/helpers/pdpHelpers";
import { getProductOptions, selectPLPVariant } from "@/helpers/pdpHelpers/pdpVariantHelpers";
import { bodyOverflow } from "@/helpers/userHelpers";
import QuickBuyIcon from "@/components/Logos/QuickBuy";
import { getVariantFinalOptions, hasLocalItem } from "@/helpers/plpHelper";
import { PRODUCT_MEDIA_QUERY } from "gql/productMedia";
import apolloClient from "gql/apolloClient";
import { setCart } from "./Nosto";
import { addToCart, openMiniCart, openQBMiniCart } from "@/redux/actions/addToCartAction";
import { setScrollPos } from "@/redux/actions/drawerAction";
import { getVariantPrice } from "@/helpers/pdpHelpers/priceHelpers";
import { addToBag } from "@/helpers/cartEventHelper";
import { useDispatch } from "react-redux";
import style from "@/components/common/common.module.scss";
import {algoliaConversionTracking} from "@/helpers/productHelper";


const PLPMobileSwatches = ({
  handle, 
  productImage,
  bundleQuickBuy, // Enable GA event for bundle
  setProduct,
  setVariants,
  product,
  variants,
  badge_curated,
  search,
  objectId,
  queryId,
  device
}) => {
  const [visibility, setVisibility] = useState(false);
  const [data, setData] = useState({});
  const [type, setType] = useState("");
  const [buttonCTA, setButtonCTA] = useState("");
  const [selected, setSelected] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedLetter, setSelectedLetter] = useState(null);
  const [quickBuyClicked,setQuickBuyClicked]=useState(false);
  const [loading, setLoading] = useState(false);
  const [QBloading, setQBLoading] = useState(false);
  const dispatch = useDispatch();
  const [selectedVariant, setSelectedVariant] = useState();

  const popupCloseHandler = () => {
    setVisibility(false);
    setSelected(null);
  };
  const [active, setActive] = useState(false);
  useEffect(() => {
    if (selected) 
    {
      setActive(selected);
      setButtonCTA('Add to bag');
      //selected variant data format in required object format
      setSelectedVariant(selectPLPVariant(
        null,
        variants.variantMap,
        selectedColor,
        selectedSize,
        selectedLetter,
        variants.sizes ? variants.sizes.length : 0,
        setSelectedSize,
        product.id
      ));
    } else {
      setButtonCTA(buttonCTA);
    }
  }, [selected]);
  useEffect(() => {
    if (!loading && !quickBuyClicked) 
    {
      popupCloseHandler();
    } 
  }, [loading]);

  const getProductData = async (handle) => {
    try {
        const result = await apolloClient.query({
            query: PRODUCT_MEDIA_QUERY,
            variables: {
                handle: handle,
            },
        });
        return result.data;
    } catch (e) {
        console.log("Quick buy product data fetch", e);
    }
}

  const assignVariants = (product,variants) => {
      //map variant data wrt sizes when size is not undefined
      setSelectedSize(variants.sizes && variants.sizes.length == 1 ? variants.sizes.find(ele => ele !== undefined) : null);
      //check if the variant has personalized tags which indicates that it will have letter variants
      if (product?.tags?.includes("personalized")) {
          setSelectedLetter(variants.letters && variants.letters.length == 1 ? variants.letters.find(ele => ele != undefined) : null);
          setSelectedColor(null);
      } else {
          setSelectedColor(variants.colors && variants.colors.length == 1 ? variants.colors.find(ele => ele !== undefined) : null);
          setSelectedLetter(null)
      }
  }

  const selectHandler = (e, ele) => {
    e.preventDefault();
    e.stopPropagation();
    if (setSelected) setSelected(ele);
    setActive(ele);
    if (type == "size") {
      setSelectedSize(ele);
    } else if (type == "color") {
      setSelectedColor(ele);
    } else if (type == "letter") {
      setSelectedLetter(ele);
    }
  };

  const tagData = useMemo(
    () => getShopifyTagData(product.tags),
    [product.tags]
  );
  let { sizes } = useMemo(
    () => getProductOptions(product.options),
    [product]
  );
  const sizeGuideType = useMemo(
    () => getSizeGuideType(tagData, sizes),
    [tagData, sizes]
  );
  
  useEffect(() => {
    if (visibility) {
    document.querySelector("body").classList.add("disable-scroll");
    }
    else {
      document.querySelector("body").classList.remove("disable-scroll");
    }
  }, [visibility])

  const QBPopUpContent = () => {
    return (
      <>
        <div className="first_row">
          <Srcset src={productImage} className="product_image" />
          <div className="mt-15 product_details">
            <div className="small-xs mb-5">{product.vendor}</div>
            <div className="x-small-xs">{product.title}</div>
          </div>
        </div>
        <div className="typography-wrap">
          <div className="custom-dropdown open">
            <div className="dropdown-lable small-xs">
              {selected?type.charAt(0).toUpperCase()+type.slice(1)+" selected : "+active:"Select your "+type}
            </div>
            <div className="dropdown-list">
              <ul className="dropdown-ul">
                {data.map((element, index) => {
                  let hasLocal = hasLocalItem(variants.variantMap,element);
                  return (<li className={`${bundleQuickBuy ? 'ga-bundle-quick-buy' : ''} ${type == "color" ? "color" : ""} ${element == selected ? "qb-active" : ""}`} key={index} onClick={(e) => {
                    selectHandler(e, element);
                  }}>
                    {/* To display the fast shipping badge for Quick Buy PLP */}
                    {type == "color" && variants.hexCodeArray[index] && variants.hexCodeArray[index].length && <div className="swatches-item">
                      <label className={`${element==active?styles.active:""}`}>
                        <span className={`swatches-type ${commonStyle.main}`} style={{ backgroundColor: `#${variants.hexCodeArray[index][0]}` }}></span>
                      </label>
                    </div>}
                    {type == "color" && !variants.hexCodeArray[index] && <div className="swatches-item">
                      <label className={`${element==active?styles.active:""}`}>
                        <span className={`swatches-type ${commonStyle.main}`}></span>
                      </label>
                    </div>}
                    <span className={`${hasLocal?style.fast_shipping_plp_mobile:""}`}> {element}</span>
                  </li>)
                })}
              </ul>
            </div>
            {
              type == "size" && sizeGuideType &&
              <div className="sizeguide_wrapper">
                <SizeGuidePopUp sizeGuideType={sizeGuideType} className="xx-small-xs" isClose={true} plp={true} />
              </div>
            }
          </div>
        </div>
        <div>
          <button
            type="button"
            className={`btn-primary btn_loading ${styles["add-to-bag-btn"]} ${loading ? "loading" : ""}`}
            onClick={(e) => {
              if (!loading) {
                setQuickBuyClicked(true);
              }
            }}
          >
            <span className="small-xs">{buttonCTA}</span>
          </button>
        </div>
      </>
    )
  }

  const handleOpen = async () => {
    setQBLoading(true);
    const data = await getProductData(handle);
    
    if (data?.productByHandle) {
      setProduct(data?.productByHandle);
      //setVarints array with mapping
      const finalOptions= getVariantFinalOptions(data?.productByHandle?.variants?.edges, data?.productByHandle?.options, data?.productByHandle?.tags, handle);
      setVariants(finalOptions)
      //intialized sizes, letter, color variants
      assignVariants(data?.productByHandle, finalOptions);
      if (finalOptions) {
        // only having one variant
        if (finalOptions.singleVariant && finalOptions.showQuickBuy) {
          let singleVariantData= selectPLPVariant(
            null,
            finalOptions.variantMap,
            finalOptions.colors,
            finalOptions.sizes,
            finalOptions.letters,
            finalOptions.sizes ? finalOptions.sizes.length : 0,
            setSelectedSize,
            data?.productByHandle.id
          );
          let response = await addToBag(singleVariantData, badge_curated, data?.productByHandle, {"device":device});
          await setCart(response);
          dispatch(addToCart(response));
          dispatch(setScrollPos(window.scrollY))
          dispatch(openMiniCart(true));
          dispatch(openQBMiniCart(true));
          setTimeout(() => {
            dispatch(openMiniCart(false));
            dispatch(openQBMiniCart(false));
            document.querySelector(".search_wrapper").classList.remove("shift_back");
            document.querySelector("body").classList.remove("v-main-none");
          }, 5000);
          setQuickBuyClicked(false);
          setLoading(false);
        } 
        if (finalOptions.showQuickBuy && finalOptions.colors.length > 1) {
          setData(finalOptions.colors);
          setType("color")
          setVisibility(true);
        } else if (finalOptions.showQuickBuy && finalOptions.sizes.length > 1) {
          setData(finalOptions.sizes);
          setType("size")
          setVisibility(true);
        }
        else if (finalOptions.showQuickBuy && finalOptions.letters.length > 1) {
          setData(finalOptions.letters);
          setType("letter")
          setVisibility(true);
        }
        if (!finalOptions.showQuickBuy) {
          //redirect to PDP if variant combination eg size & color, size & letter
          //OS-6073 objectId is appended to select the respective variant when it is having multiple colour options
          window.location.href = `${process.env.NETLIFY_URL}/products/${handle}${objectId ? `?objectId=${objectId}` : ""}`;
        }
      }
    }
    setQBLoading(false);
  }

  const performAddToCart = async (e) => {
    setLoading(true);
    let price,
    salePrice;
    //only send the conversion event if object id is present
    //This is done to prevent tracking from from anywhere else expect PLP
    const quickbuy = true; //to pass that the value is coming from quickbuy
    if(objectId){
      algoliaConversionTracking(objectId,queryId,quickbuy);
    }
    let priceObj = getVariantPrice(selectedVariant, product.productType);
    if (priceObj.returnedPrice) {
      price = priceObj.returnedPrice;
    }
    if (priceObj.returnedSalePrice) {
      salePrice = priceObj.returnedSalePrice;
    }
    let finalProductPrice = salePrice ? salePrice : price;
    let gaPrice = finalProductPrice.replace(/\,/g,'');
    product.price = parseFloat(gaPrice.substring(1));
    let response = await addToBag(selectedVariant, badge_curated, product);
    await setCart(response);
    dispatch(addToCart(response));
    dispatch(setScrollPos(window.scrollY))
    dispatch(openMiniCart(true));
    dispatch(openQBMiniCart(true));
    popupCloseHandler();
    if(search) {	
      document.querySelector("body").classList.add("v-main-none");	
    }
    setTimeout(() => {	
      document.querySelector(".search_wrapper").classList.add("shift_back");	
    }, 200);	
    setTimeout(() => {
      dispatch(openMiniCart(false));
      dispatch(openQBMiniCart(false));
      document.querySelector(".search_wrapper").classList.remove("shift_back");
      document.querySelector("body").classList.remove("v-main-none");
    }, 5000);
    setQuickBuyClicked(false);
    setLoading(false);
  };

  useEffect(() => {
    if (quickBuyClicked && selectedVariant) {
      performAddToCart();
    }
  }, [quickBuyClicked]);

  useEffect(() => {
    setButtonCTA("Choose your "+type+" :")
  },[type])

  return (
    <>
      <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleOpen(); }} className={QBloading?"loading":""}>
        <QuickBuyIcon stroke="#2f2f30" fill="none" className={`${styles.quick_buy_icons} ${bundleQuickBuy ? "ga-bundle-quick-buy": ""}`}/>
      </span>
      {visibility ?
        <PopUp onClose={popupCloseHandler} show={visibility} closeIcon={true} wrapperClass="quick-buy-popup">
          <QBPopUpContent />
        </PopUp> : <></>
      }
    </>
  );
};

export default PLPMobileSwatches;
